<template>
  <v-container fluid grid-list-md>
    <v-toolbar class="elevation-5 mb-3" style="z-index: 1">
      <v-btn icon @click="$router.go(-1)">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title v-if="$route.params.instance_id">{{ form.name }}</v-toolbar-title>
      <v-toolbar-title v-else>New Instance</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="my-0" color="success" @click="save">save</v-btn>
    </v-toolbar>
    <progress-bar></progress-bar>
    <v-layout row wrap>
      <v-flex xs12 sm4>
        <v-card>
          <v-card-text>
            <div class='sl_form_title'>
              <h3>Main info</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <v-text-field v-model="form.name" :error-messages="errorMessages('name')"
                          label="Title"></v-text-field>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4>
        <v-card>
          <v-card-text>
            <div class='sl_form_title'>
              <h3>Settings</h3>
            </div>
            <v-divider class='my-2'></v-divider>
            <sl-extended-select
                label="Select users"
                v-model="form.users"
                :data="users"
                :withOptions="false"
            />
            <sl-extended-select
                label="Select the features"
                v-model="form.features"
                :data="features"
                :withOptions="false"
            />
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins'
  import users from '@/components/sl-extended-select'

  export default {
    name: 'InstancesFormPage',
    mixins: [mixins.errors, mixins.form, mixins.preloader],
    data() {
      return {
        api: this.$api.instances,
        users: [],
        features: [],
        form: {
          name: '',
          users: [],
          features: [],
        },
      }
    },
    components: {
      'sl-extended-select': users,
    },
    mounted() {
      if (this.$route.params.instance_id > 0) {
        this.load(this.$route.params.instance_id)
      }

      this.$api.features.list({unlimit: 1}).then(({data}) => {
        this.features = data
      })

      this.$api.users.list({unlimit: 1, withoutInstanceFilter: 1}).then(({data}) => {
        this.users = data
      })
    },
  }
</script>
